module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "_idGenObjectStyleOverride-1"
  }, [_c('p', {
    staticClass: "ORIM-Dedication--Front-Matter-"
  }, [_vm._v("Here’s to Iowa, and Minnesota, and Nebraska, and")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Dedication--Front-Matter-"
  }, [_vm._v("all the well-meaning people who raised us. We love them")]), _vm._v(" "), _c('p', {
    staticClass: "ORIM-Dedication--Front-Matter-"
  }, [_vm._v("even as they cast us into the flames.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-79bf821c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Untitled119.vue
// module id = 66
// module chunks = 0